<template>
	<footer class="Footer">
        <b-container fluid class="rodapeFooter" style="padding-left: 0px; padding-right: 0px;">
            
            <b-row  no-gutters class="inicioFooter">
                <b-col cols="12">
                    <mq-layout mq="sm+">
                        <div class="efeitoFundoFooter">
                            <div class="hionGloboFooter"><HionEffect /></div>
                        </div>
                    </mq-layout>
                </b-col>
            </b-row>

            <b-row  no-gutters class="meioFooter">
                <b-col cols="12" sm="3" lg="1" order="3" order-sm="3" order-lg="1"><mq-layout mq="xs"><div class="dirReservadoFooter text-center">2020&#169; TODOS OS DIREITOS RESERVADOS</div></mq-layout></b-col>
                <b-col cols="12" sm="12" lg="3" order="2" order-sm="2" order-lg="2" class="text-center text-sm-center">
                    <div class="emailhion">hion@hiontecnologia.com.br</div>
                    <div class="redessociais">
                        <a href="https://www.linkedin.com/company/hiontecnologia/" target="_blank"><i class="fab fa-linkedin socialIcon"></i></a>
                        <a href="https://www.instagram.com/" target="_blank"><i class="fab fa-instagram socialIcon"></i></a>
                        <a href="https://www.youtube.com/" target="_blank"><i class="fab fa-youtube socialIcon"></i></a>
                        <a href="https://www.facebook.com/" target="_blank"><i class="fab fa-facebook-f socialIcon"></i></a>
                        <a href="https://twitter.com/" target="_blank"><i class="fab fa-twitter socialIcon"></i></a>
                    </div>
                </b-col>
                <b-col cols="4" sm="3" lg="1" order="4" order-sm="4" order-lg="5" class="text-right text-sm-left">
                    <mq-layout mq="lg+">
                        <div class="esquerdo"><LinhaHorizontal :configLinhas="configLinhas" /></div>
                    </mq-layout>
                </b-col>
                <b-col cols="4" sm="3" lg="3" order="5" order-sm="5" order-lg="6">
                    <mq-layout mq="lg+">
                        <nav class="menuFooter">
                            <ul>
                                <li class="botaoFooter">
                                    <router-link to="/">Home</router-link>
                                </li>
                                <li class="botaoFooter">
                                    <router-link to="/Sobre">Quem Somos</router-link>
                                </li>
                                <li class="botaoFooter">
                                    <router-link to="/Tecnologia">Soluções e Tecnologia</router-link>
                                </li>
                                <li class="botaoFooter">
                                    <router-link to="/Contatos">Contato</router-link>
                                </li>
                            </ul>
                        </nav>
                    </mq-layout>
                </b-col>
                <b-col cols="4" sm="3" lg="1" order="6" order-sm="6" order-lg="9">
                    <mq-layout mq="lg+">
                        <div  class="direito"><LinhaHorizontalY :configLinhas="configLinhas" /></div>
                    </mq-layout>
                </b-col>
                <b-col cols="12" sm="12" lg="3" order="1" order-sm="1" order-lg="10"
                    class="logoFooter text-center text-sm-center">
                        <router-link to="/">
                            <mq-layout mq="sm+">
                                <b-img-lazy 
                                        :src="require('../../assets/hion_logo_positivo.png')" 
                                        alt="Hion Tecnologia" >
                                </b-img-lazy>
                            </mq-layout>
                            <mq-layout mq="xs">
                                <b-img-lazy 
                                        :src="require('../../assets/logo_bola_preto.jpg')" 
                                        alt="Logotipo Tela Pequena" >
                                </b-img-lazy>
                            </mq-layout>
                        </router-link>
                </b-col>
            </b-row>

            <b-row  no-gutters class="meio2Footer">
                <b-col cols="12" />
            </b-row>

            <b-row  no-gutters class="fimFooter">
                <b-col cols="12" sm="1" lg="1" order="1" order-sm="1" order-lg="1" />
                <b-col cols="12" sm="5" lg="5" order="3" order-sm="2" order-lg="2" class="copyright text-sm-left text-lg-left">
                    <mq-layout mq="sm+">
                        <router-link to="/">
                            <b-img-lazy 
                                :src="require('../../assets/hion-footer-logo.png')" 
                                alt="Hion Tecnologia 2020" >
                            </b-img-lazy>
                        </router-link>
                    </mq-layout>
                </b-col>
                <b-col cols="12" sm="5" lg="5" order="2" order-sm="6" order-lg="6" class="copyright text-center text-sm-right text-lg-right">
                    <a href="https://agenciarumodigital.com.br/" target="_blank">
                        <b-img-lazy 
                                :src="require('../../assets/logo-footer-rumodigital-01.png')" 
                                alt="agenciarumodigital.com.br" >
                        </b-img-lazy>
                    </a>
                </b-col>
                <b-col cols="12" sm="1" lg="1" order="4" order-sm="12" order-lg="12" />
            </b-row>
        </b-container>
	</footer>
</template>

<script>
export default {
    name: "Footer",
    components: { 
        LinhaHorizontal: () => import(/* webpackChunkName: "linhaHorizontalFooter" */ "../efeitos/LinhaHorizontal.vue"), 
        LinhaHorizontalY: () => import(/* webpackChunkName: "linhaHorizontalYFooter" */ "../efeitos/LinhaHorizontalY.vue"), 
        HionEffect: () => import(/* webpackChunkName: "hionGloboFooter" */ "../efeitos/hion_globo.vue"),
    },
    data() {
        return {
            configLinhas: {
                backgroundLinhas: "black",
                CorLinhas: "#008fac"
            }
        };
    }
}
</script>

<style>
    .Footer {
        height: 505px;
        width: 100%;
        grid-area: footer;
        background-color: #000;
        color: #eee;
        z-index: 0;
        overflow: hidden;
    }
    .efeitoFundoFooter {
        margin: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
    }
    .hionGloboFooter {
        height: 370px;
        width: 370px;
        position: absolute;
        left: calc(100% - 270px);
        top: -40px;
        transform: rotate(35deg);
        opacity: 0.25;
    }

    .rodapeFooter {
        margin:0;
        height: 100%;
        width: 100%;
        z-index: 2;
    }

    .inicioFooter {
        height: 95px;
        width: 100%;
        background-color: #000;
    }
    .meioFooter {
        height: 210px;
        width: 100%;
        background-color: #000;
    }
    .meio2Footer {
        height: 95px;
        width: 100%;
        background-color: #000;
    }
    .fimFooter {
        height: 105px;
        width: 100%;
        background-color: #008fac;
        color: #000;
        font-size: 0.8rem;
		font-family: 'Play';
    }
    .logoFooter {
        padding-top: 35px;
        padding-left: 35px !important;
    }
    .logoFooter img {
        height: 70px;
        width: 150px;
    }

    .menuFooter {
        font-family: 'Play';
        padding-top: 35px;
        padding-left: 35px;
    }
    .menuFooter ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    .menuFooter li {
        padding: 1px 0px;
    }
    .menuFooter a {
        text-decoration: none;
        color: #eee;
        padding: 4px;
    }
    .menuFooter a:hover {
        text-decoration: none;
        color: #eee;
    }

    .botaoFooter:hover a {
        border: solid 2px #008fac;
        border-radius: 12px;
    }

    .emailhion {
        padding-top: 35px;
        font-family: 'Raleway';
    }
    .redessociais {
        padding-top: 35px;
    }
    .socialIcon {
        padding-right: 15px;
        font-size: 1.4em;
    }
    .redessociais a {
        text-decoration: none;
        color: #eee;
    }
    .redessociais a:hover {
        color: #008fac;
    }
    .esquerdo {
        width: 240px;
        height: 55px;
        transform: rotate(270deg);
        margin-top: 80px;
        margin-left: -100px;
    }
    .direito {
        transform: rotate(270deg);
        width: 240px;
        height: 55px;
        margin-top: 80px;
        margin-left: -100px;
    }

    .copyright {
        padding-top: 35px;
    }
    .copyright img {
        height: 30px;
        width: 240px;
    }

 /* MEDIA QUERY SM E MD *********************************************************/
@media (min-width: 576px) and (max-width:991px) { /* MD E SM */

.copyright img {
    height: 25px;
    width: 200px;
}

.logoFooter {
    padding-left: 0px !important;
}
.redessociais {
    padding-left: 15px;
}

}

/* MEDIA QUERY XS ****************************************************/
@media (max-width:575px) { /* XS */

.logoFooter {
    padding-top: 0px !important;
    padding-left: 0px !important;
}
.logoFooter img {
    height: 100px;
    width: 100px;
}
.redessociais {
    padding-left: 15px;
}
.socialIcon {
    padding-right: 15px;
    font-size: 1.8em;
}
.dirReservadoFooter {
    padding-top: 35px;
    font-family: 'Raleway';
    color: rgb(131, 130, 130);
    font-size: 12px;
}
.copyright img {
    height: 25px;
    width: 200px;
}

}

</style>